import { CustomComponentsProvider } from '@husky-x/gatsby-theme-husky';
import { HistoryList } from '@husky-x/history-list';

import { HistoryMock } from './custom-components-mocks';
import React from 'react';
import { SuitabilityChecker } from './src/@husky-x/gatsby-theme-husky/components/SuitabilityChecker/SuitabilityChecker';

export const wrapRootElement = ({ element }) => (
  <CustomComponentsProvider
    list={[
      {
        key: 'HistoryCustomComponent',
        component: () => <HistoryList {...HistoryMock} />,
      },
      {
        key: 'custom_component_suitability_checker',
        component: SuitabilityChecker,
      },
    ]}
  >
    {element}
  </CustomComponentsProvider>
);
